export default __webpack_public_path__ + "static/media/909.64804103.png";